import { render, staticRenderFns } from "./QuestForm.vue?vue&type=template&id=18c6ba46&scoped=true&"
import script from "./QuestForm.vue?vue&type=script&lang=js&"
export * from "./QuestForm.vue?vue&type=script&lang=js&"
import style0 from "./QuestForm.vue?vue&type=style&index=0&id=18c6ba46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c6ba46",
  null
  
)

export default component.exports